
      import API from "!../../../../../web/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../web/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../web/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../web/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../web/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../web/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../web/node_modules/css-loader/dist/cjs.js!./skin.min.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../web/node_modules/css-loader/dist/cjs.js!./skin.min.css";
       export default content && content.locals ? content.locals : undefined;
